import { gxRejectRtpRequestApi } from "@/app/apiConfig/services/paymentsAbstractApiLayer";
import { useState } from "react";

interface PayloadType {
  rtpTransId: number | null;
  remarks: string | null;
}
export const useRejectRtpRequest = () => {
  const [rejectLoading, setRejectLoading] = useState<boolean>(false);
  const rejectRequestApi = async ({ rtpTransId, remarks }: PayloadType) => {
    if (!(rtpTransId && remarks)) return;
    try {
      setRejectLoading(true);
      const payload = {
        rtpTransId,
        remarks,
      };
      await gxRejectRtpRequestApi(payload);
    } catch (err) {
      console.log("Error in rejectRequestApi::", err);
    } finally {
      setRejectLoading(false);
    }
  };
  return { rejectLoading, rejectRequestApi };
};
